import { constants } from "redux/constants/redux-constants";

const initialState = {
  addCdssSuffix: false,
};

const AddCdssSuffixReducer = (state = initialState, action) => {
  switch (action.type) {
    case constants.CDSS.SET_ADD_SUFFIX:
      return {
        ...state,
        addCdssSuffix: action.payload,
      };
    default:
      return state;
  }
};

export default AddCdssSuffixReducer;